import { instanceApi } from '@/services/ProviderService'

export default {
    login(username, password){
        console.log("Start Login")
        return instanceApi(false).post(`/auth/login`, { "username": username, "password": password} );
    },
    userInfo() {
        return instanceApi().get(`/api/user/info/`).then(res => res.data);
    }
}
